export default __webpack_public_path__ + "static/flareup-faac3fd47bf758f1105bf1225a000335.png";